export default __webpack_public_path__ + "static/media/mayrock.a4be2b30.png";